import { describeResource } from '@siteless/resource';
import { z } from 'zod';
import { auth } from '../../config/firebase';

let LeagueMembersInfoSchema = z.record(
  z.string(),
  z.object({
    email: z.optional(z.string()),
    phoneNumber: z.optional(z.string()),
    createdAt: z.optional(z.string()),
  }),
);

export type LeagueMembersInfoType = z.infer<typeof LeagueMembersInfoSchema>;

export let LeagueMembersInfoResource = describeResource(
  'LeagueMembersInfoResource',
  {
    get: async (leagueId?: string) => {
      if (!leagueId) return {};

      let token = await auth.currentUser?.getIdToken();
      let raw = await window.fetch(
        `https://us-central1-fantasy-awards-siteless.cloudfunctions.net/leagueOwnersGetLeagueMembersInfoHandler?leagueId=${encodeURIComponent(leagueId)}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        },
      );

      if (!raw.ok) {
        return {};
      }

      let { membersInfo } = await raw.json();
      return LeagueMembersInfoSchema.parse(membersInfo);
    },
  },
);

export default LeagueMembersInfoResource;
